import { css } from 'lit';
import sharedStyles from '../../../shared/styles';

export default [
  sharedStyles,
  css`
    .partners-registration-form-confirmation h2 {
      font-weight: 700;
      line-height: 1.2;
      color: #5B6062;
    }

    .partners-registration-form-container h4 {
      color: #777779;
    }
  `,
];
